import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg viewBox="0 0 4437 1024" width="1em" height="1em" focusable="false" fill="currentColor" aria-hidden="true"><path d="M631.107 512a370.789 370.789 0 1 0 741.577 0 370.789 370.789 0 1 0-741.577 0ZM1867.0690000000002 512a370.789 370.789 0 1 0 741.577 0 370.789 370.789 0 1 0-741.577 0ZM3103.031 512a370.789 370.789 0 1 0 741.577 0 370.789 370.789 0 1 0-741.577 0Z" /></svg>

const Ellipsis = React.forwardRef((props, ref) => {
  return (
    <IconBase name="ellipsis" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

Ellipsis.displayName = 'IconEllipsis'

export default Ellipsis
